import { get } from "lodash-es";
import React from "react";
import { classnames } from "../../utils/text";
import Button from "../Button";
import Input from "../Input";

const getKakaoAddress = (
  form,
  setForm,
  addressKey,
  zipCodeKey,
  addressDetailKey,
  callback = () => {}
) => {
  var width = 500; //팝업의 너비
  var height = 600; //팝업의 높이

  new window.daum.Postcode({
    width: width, //생성자에 크기 값을 명시적으로 지정
    height: height,

    oncomplete: (data) => {
      const { zonecode, jibunAddress, roadAddress, userSelectedType } = data;
      let addr = "";

      if (userSelectedType === "J") {
        addr = jibunAddress;
      } else {
        addr = roadAddress;
      }

      document.getElementById(zipCodeKey).value = zonecode;
      document.getElementById(addressKey).value = addr;
      setForm({ ...form, [addressKey]: addr, [zipCodeKey]: zonecode });
      callback({ zonecode, addr });
    },
  }).open({
    left: window.screen.width / 2 - width / 2,
    top: window.screen.height / 2 - height / 2,
  });
};

const AddressSearch = ({
  className,
  addrClassName,
  zipCodeClassName,
  buttonClassName,
  detailAddrClassName,
  disabled,
  onChange,
  form,
  options = {}, // addressDetailKey, addressKey , zipCodeKey
  setForm,
  callback = () => {},
}) => {
  const {
    addressKey = "address",
    zipCodeKey = "zipCode",
    addressDetailKey = "addressDetail",
  } = options;

  return (
    <div className={classnames("component-address", className)}>
      <div className="address-1">
        <Input
          className={zipCodeClassName || "zipCode"}
          id={zipCodeKey}
          name={zipCodeKey}
          placeholder="우편번호"
          disabled={disabled}
          value={get(form, zipCodeKey) || ""}
        />

        <Button
          color="gray-line"
          className={buttonClassName}
          onClick={() =>
            getKakaoAddress(
              form,
              setForm,
              addressKey,
              zipCodeKey,
              addressDetailKey,
              callback
            )
          }
          disabled={disabled}
        >
          주소검색
        </Button>
      </div>
      <div className="address-2">
        <Input
          className={addrClassName || "address"}
          id={addressKey}
          name={addressKey}
          placeholder="주소"
          disabled={disabled}
          value={get(form, addressKey) || ""}
        />
      </div>
      <div className="address-2">
        <Input
          className={detailAddrClassName || "address-detail"}
          id={addressDetailKey}
          name={addressDetailKey}
          placeholder="상세주소"
          disabled={disabled}
          value={get(form, addressDetailKey) || ""}
          onChange={onChange}
        />
      </div>
    </div>
  );
};
export default AddressSearch;
